import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FuncionamentoEsquerdaComponent } from './funcionamento-esquerda.component';
import { TranslateModule } from '@ngx-translate/core';
import { RouterModule } from '@angular/router';
import { LocalizeRouterModule } from '@gilsdav/ngx-translate-router';

@NgModule({
  declarations: [
    FuncionamentoEsquerdaComponent
  ],
  imports: [
    TranslateModule,
    CommonModule,
    RouterModule,
    LocalizeRouterModule
  ],
  exports: [
    FuncionamentoEsquerdaComponent
  ]
})

export class FuncionamentoEsquerdaModule { }
